import {
  FooterProgressBar,
  type ProgressBarProps,
} from '../../Questionnaire/FooterProgressBar'

export const BottomNavContainer = ({
  children,
  progressBarProps,
}: {
  children: React.ReactNode
  progressBarProps?: ProgressBarProps
}) => {
  return (
    <div className='fixed bottom-0 left-0 w-screen bg-gradient-to-t from-[rgba(255,255,255,1)] via-[rgba(255,255,255,0.98),90%] to-[rgba(255,255,255,0)] px-2 pt-6 md:px-0'>
      {progressBarProps ? <FooterProgressBar {...progressBarProps} /> : null}
      <div className='mx-auto flex max-w-6xl flex-col items-center justify-end gap-4 pb-4 md:flex-row md:pb-10'>
        {children}
      </div>
    </div>
  )
}
